import * as constants from './constants'
import { decode as decodeStructure } from './lib/structure'
import { decode as decodePrimitive } from './lib/primitive'

export {
  constants,
  decodeStructure,
  decodePrimitive
}
